import type { UserJobs } from 'types/common/account/user'

export type IntercomUserData = {
  // Standard Intercom user data
  email?: string
  name?: string
  user_id?: string
  user_hash?: string
  created_at?: number
  unsubscribed_from_emails?: boolean
  language_override?: string
  company?: Intercom_.IntercomSettings['company']
  companies?: Intercom_.IntercomSettings['companies']
  // Custom user data
  job_title?: UserJobs
  user_scope?: 'singleUser' | 'receiver' | 'sender'
  first_name?: string
  last_name?: string
  // customer_id is the id given to the sender by the receiver
  customer_id?: string
  subdomainHandle?: string
}

export const useIntercom = () => {
  const intercomBoot = (userData?: IntercomUserData) => {
    window.Intercom?.('boot', {
      app_id: process.env.INTERCOM_APP_ID,
      ...userData,
    })
  }

  const intercomUpdate = (userData?: IntercomUserData) => {
    window.Intercom?.('update', userData)
  }

  const intercomShutdown = () => {
    window.Intercom?.('shutdown')
  }

  return { intercomBoot, intercomUpdate, intercomShutdown }
}
